
document.addEventListener('DOMContentLoaded', function () {
    var ED_BUY_COLLECTION_HANDLE = 'nw26slenld5efmqk0hc5';
    var ED_BUY_COLLECTION_PATH = '/collections/' + ED_BUY_COLLECTION_HANDLE;
    var ED_BUY_NOTICE_KEY = 'edbuyNoticeDismissed';
    var ED_BUY_NOTICE_MESSAGE = 'You are now in the Department of Education approved catalogue. Please only select products listed in this collection.';

    function getQueryParam(name) {
        return new URLSearchParams(window.location.search).get(name);
    }

    function hasPunchoutSession() {
        return typeof getCookie_Punchout === 'function' && getCookie_Punchout('punchout_sess_id');
    }

    function isEdBuyMode() {
        return Boolean(hasPunchoutSession());
    }

    function isBlank(value) {
        return !value || value.trim().length === 0;
    }

    function buildEdBuySearchUrl(query) {
        return ED_BUY_COLLECTION_PATH + '?edbuy_search=' + encodeURIComponent(query);
    }

    function redirectEdBuySearch(event) {
        var form = event.target;
        var queryInput = form.querySelector('[name="q"]');
        var query = queryInput ? queryInput.value : '';

        if (isBlank(query)) {
            return;
        }

        event.preventDefault();
        window.location.href = buildEdBuySearchUrl(query);
    }

    function configureEdBuySearchForm(form) {
        if (!form) {
            return;
        }

        form.setAttribute('data-edbuy-search-ready', 'true');

        var typeInput = form.querySelector('[name="type"]');
        if (!typeInput) {
            typeInput = document.createElement('input');
            typeInput.type = 'hidden';
            typeInput.name = 'type';
            form.appendChild(typeInput);
        }
        typeInput.value = 'product';

        form.setAttribute('action', '/search');

        var viewInput = form.querySelector('[name="view"]');
        if (!viewInput) {
            viewInput = document.createElement('input');
            viewInput.type = 'hidden';
            viewInput.name = 'view';
            form.appendChild(viewInput);
        }
        viewInput.value = 'edbuy';

        form.addEventListener('submit', redirectEdBuySearch);
    }

    function configureEdBuySearchUi() {
        var searchForms = document.querySelectorAll('[data-edbuy-search-form]');

        Array.prototype.forEach.call(searchForms, function (form) {
            configureEdBuySearchForm(form);
        });

        var searchTypeControls = document.querySelectorAll('[data-edbuy-search-mode-control]');
        Array.prototype.forEach.call(searchTypeControls, function (control) {
            control.setAttribute('hidden', 'hidden');
            control.setAttribute('aria-hidden', 'true');
        });

        var predictiveWrappers = document.querySelectorAll('[data-edbuy-hide-in-session]');
        Array.prototype.forEach.call(predictiveWrappers, function (wrapper) {
            wrapper.setAttribute('hidden', 'hidden');
            wrapper.setAttribute('aria-hidden', 'true');
        });
    }

    function showEdBuyCollectionSearchNotice() {
        var notice = document.querySelector('[data-edbuy-collection-notice]');
        var searchTerm = getQueryParam('edbuy_search');

        if (!notice || !searchTerm || window.location.pathname !== ED_BUY_COLLECTION_PATH) {
            return;
        }

        notice.textContent = 'Search for "' + searchTerm + '". Browse this collection to select approved products.';
        notice.removeAttribute('hidden');
    }

    function normalizeSearchValue(value) {
        return (value || '').toString().toLowerCase().trim();
    }

    function productMatchesEdBuySearch(product, searchTerm) {
        var normalizedTerm = normalizeSearchValue(searchTerm);
        var searchableFields = [
            product.title,
            // product.vendor,
            // product.product_type,
            // (product.tags || []).join(' '),
            // product.body_html
        ].join(' ').toLowerCase();

        return searchableFields.indexOf(normalizedTerm) !== -1;
    }

    function escapeHtml(value) {
        return (value || '').toString()
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    }

    function normalizeMoneyInput(value) {
        if (typeof value === 'string' && value.indexOf('.') !== -1) {
            return Math.round(parseFloat(value) * 100);
        }

        return Number(value || 0);
    }

    function formatEdBuyMoney(value) {
        var cents = normalizeMoneyInput(value);

        if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
            return theme.Currency.formatMoney(cents, theme.moneyFormat);
        }

        return '$' + (cents / 100).toFixed(2);
    }

    function getEdBuyPriceInfo(product) {
        // The /collections/<handle>/products.json endpoint exposes pricing and
        // availability on each variant, not on the product itself, so derive the
        // values the card needs from product.variants.
        var variants = product.variants || [];
        var prices = [];
        var available = false;
        var compareAtPrice = 0;

        variants.forEach(function (variant, index) {
            prices.push(normalizeMoneyInput(variant.price));

            if (variant.available) {
                available = true;
            }

            if (index === 0) {
                compareAtPrice = normalizeMoneyInput(variant.compare_at_price);
            }
        });

        if (!prices.length) {
            return { price: 0, priceMin: 0, priceVaries: false, compareAtPrice: 0, available: false };
        }

        var minPrice = Math.min.apply(null, prices);
        var maxPrice = Math.max.apply(null, prices);

        return {
            price: minPrice,
            priceMin: minPrice,
            priceVaries: minPrice !== maxPrice,
            compareAtPrice: compareAtPrice,
            available: available
        };
    }

    var ED_BUY_GRID_MAX_HEIGHT = 250;

    function buildEdBuyProductCard(product, indexClass) {
        var imageObject = (product.images && product.images.length) ? product.images[0] : null;
        var image = '';
        if (product.image && product.image.src) {
            image = product.image.src;
        } else if (imageObject) {
            image = imageObject.src ? imageObject.src : imageObject;
        }

        var productUrl = '/products/' + product.handle;
        var title = escapeHtml(product.title);
        var priceInfo = getEdBuyPriceInfo(product);
        var compareAtPrice = priceInfo.compareAtPrice;
        var price = priceInfo.price;
        var onSale = compareAtPrice > price;
        var soldOut = priceInfo.available === false;
        var priceText = 'Price on Application';
        if (price > 0) {
            if (priceInfo.priceVaries && priceInfo.priceMin) {
                priceText = 'From ' + formatEdBuyMoney(priceInfo.priceMin);
            } else {
                priceText = formatEdBuyMoney(price);
            }
        }
        var priceMarkup = onSale
            ? '<div class="price__sale"><dt><span class="visually-hidden visually-hidden--inline">Sale price</span></dt><dd><span class="price-item price-item--sale">' + priceText + '</span></dd><div class="price__compare"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><s class="price-item price-item--regular">' + formatEdBuyMoney(compareAtPrice) + '</s></dd></div></div>'
            : '<div class="price__regular"><dt><span class="visually-hidden visually-hidden--inline">Regular price</span></dt><dd><span class="price-item price-item--regular">' + priceText + '</span></dd></div>';
        // Match the native product card: the theme forces .grid-view-item__image
        // to position:absolute, so the wrapper needs a padding-top spacer (sized
        // to the image aspect ratio) to give it height, plus a max-width cap that
        // mirrors snippets/image-style.liquid for the collection grid.
        var aspectPadding = 100;
        var wrapperStyle = '';
        if (imageObject && imageObject.width && imageObject.height) {
            var aspectRatio = imageObject.width / imageObject.height;
            aspectPadding = (100 / aspectRatio);
            var maximumHeight = Math.min(imageObject.height, ED_BUY_GRID_MAX_HEIGHT);
            var maximumWidth = Math.round(maximumHeight * aspectRatio);
            wrapperStyle = ' style="max-width:' + maximumWidth + 'px;"';
        }
        var imageMarkup = image
            ? '<div class="product-card__image-with-placeholder-wrapper edbuy-search-results__image-shell" data-image-loading-animation><div class="grid-view-item__image-wrapper product-card__image-wrapper edbuy-search-results__image-wrapper"' + wrapperStyle + '><div style="padding-top:' + aspectPadding.toFixed(4) + '%;"><img class="grid-view-item__image edbuy-search-results__image" src="' + escapeHtml(image) + '" alt="' + title + '"></div></div></div>'
            : '';

        return '' +
            '<li class="grid__item ' + indexClass + '">' +
            '<div class="grid-view-item' + (soldOut ? ' grid-view-item--sold-out' : '') + ' product-card">' +
            '<a class="grid-view-item__link grid-view-item__image-container full-width-link" href="' + productUrl + '">' +
            '<span class="visually-hidden">' + title + '</span>' +
            '</a>' +
            imageMarkup +
            '<div class="h4 grid-view-item__title product-card__title" aria-hidden="true">' + title + '</div>' +
            '<dl class="price price--listing' + (soldOut ? ' price--sold-out' : '') + (onSale ? ' price--on-sale' : '') + '" data-price>' +
            priceMarkup +
            '<div class="price__badges price__badges--listing">' +
            '<span class="price__badge price__badge--sale" aria-hidden="true"><span>On sale</span></span>' +
            '<span class="price__badge price__badge--sold-out"><span>Sold out</span></span>' +
            '</div>' +
            '</dl>' +
            '</div>' +
            '</li>';
    }

    function setEdBuySearchState(message, isError) {
        var resultsContainer = document.querySelector('[data-edbuy-collection-results]');
        if (!resultsContainer) {
            return;
        }

        resultsContainer.innerHTML = '<div class="edbuy-search-results__status' + (isError ? ' edbuy-search-results__status--error' : '') + '">' + message + '</div>';
        resultsContainer.removeAttribute('hidden');
    }

    function hideDefaultCollectionResults() {
        var collectionRoot = document.getElementById('Collection');
        if (!collectionRoot) {
            return;
        }

        var selectors = [
            '.grid.grid--uniform',
            '.list-view-items',
            '.grid__item.small--text-center',
            '.pagination'
        ];

        selectors.forEach(function (selector) {
            var node = collectionRoot.querySelector(selector);
            if (node) {
                node.setAttribute('hidden', 'hidden');
            }
        });
    }

    function fetchEdBuyCollectionProducts(page, results) {
        var requestUrl = ED_BUY_COLLECTION_PATH + '/products.json?limit=250&page=' + page;

        return fetch(requestUrl)
            .then(function (response) {
                return response.json();
            })
            .then(function (data) {
                var products = (data && data.products) || [];
                var mergedResults = results.concat(products);

                if (products.length === 250) {
                    return fetchEdBuyCollectionProducts(page + 1, mergedResults);
                }

                return mergedResults;
            });
    }

    function buildEdBuyClearSearchLink() {
        return '<a class="edbuy-search-results__clear" href="' + ED_BUY_COLLECTION_PATH + '">Clear search</a>';
    }

    function renderEdBuyCollectionResults(products, searchTerm) {
        var resultsContainer = document.querySelector('[data-edbuy-collection-results]');
        if (!resultsContainer) {
            return;
        }

        if (!products.length) {
            setEdBuySearchState('No DOE-approved products matched "' + escapeHtml(searchTerm) + '". ' + buildEdBuyClearSearchLink());
            return;
        }

        var gridItemClass = 'small--one-half medium-up--one-quarter';
        var cards = products.map(function (product) {
            return buildEdBuyProductCard(product, gridItemClass);
        });

        resultsContainer.innerHTML =
            '<p class="edbuy-search-results__count">Showing ' + products.length + ' DOE-approved result' + (products.length === 1 ? '' : 's') + ' for "' + escapeHtml(searchTerm) + '". ' + buildEdBuyClearSearchLink() + '</p>' +
            '<ul class="grid grid--uniform grid--view-items">' + cards.join('') + '</ul>';
        resultsContainer.removeAttribute('hidden');
    }

    function runEdBuyCollectionSearch() {
        var resultsContainer = document.querySelector('[data-edbuy-collection-results]');
        var searchTerm = getQueryParam('edbuy_search');

        if (!resultsContainer || !searchTerm || window.location.pathname !== ED_BUY_COLLECTION_PATH) {
            return;
        }

        var searchInput = document.querySelector('[data-edbuy-collection-search-input]');
        if (searchInput) {
            searchInput.value = searchTerm;
        }

        hideDefaultCollectionResults();
        setEdBuySearchState('Searching DOE-approved products for "' + searchTerm + '"...');

        fetchEdBuyCollectionProducts(1, [])
            .then(function (products) {
                return products.filter(function (product) {
                    return productMatchesEdBuySearch(product, searchTerm);
                });
            })
            .then(function (products) {
                renderEdBuyCollectionResults(products, searchTerm);
            })
            .catch(function () {
                setEdBuySearchState('Unable to load DOE-approved product results right now. Please browse the catalogue directly.', true);
            });
    }


    function closeEdBuyNotice() {
        var modal = document.querySelector('[data-edbuy-notice]');
        if (!modal) {
            return;
        }

        modal.setAttribute('hidden', 'hidden');
        document.body.classList.remove('edbuy-notice-open');
        sessionStorage.setItem(ED_BUY_NOTICE_KEY, 'true');

        // Acknowledging the notice sends the user into the DOE collection, but
        // skip the redirect when they are already there to avoid a needless reload.
        if (window.location.pathname !== ED_BUY_COLLECTION_PATH) {
            window.location.href = ED_BUY_COLLECTION_PATH;
        }
    }

    function showEdBuyNotice() {
        if (sessionStorage.getItem(ED_BUY_NOTICE_KEY) === 'true') {
            return;
        }

        var modal = document.querySelector('[data-edbuy-notice]');
        if (!modal) {
            modal = document.createElement('div');
            modal.className = 'edbuy-notice';
            modal.setAttribute('data-edbuy-notice', '');
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-modal', 'true');
            modal.setAttribute('aria-labelledby', 'edbuy-notice-title');
            modal.innerHTML =
                '<div class="edbuy-notice__backdrop" data-edbuy-notice-close></div>' +
                '<div class="edbuy-notice__dialog" role="document">' +
                '<h2 id="edbuy-notice-title" class="edbuy-notice__title">Department of Education catalogue</h2>' +
                '<p class="edbuy-notice__message"></p>' +
                '<button type="button" class="btn edbuy-notice__button" data-edbuy-notice-close>Continue</button>' +
                '</div>';
            document.body.appendChild(modal);
        }

        var message = modal.querySelector('.edbuy-notice__message');
        if (message) {
            message.textContent = ED_BUY_NOTICE_MESSAGE;
        }

        modal.removeAttribute('hidden');
        document.body.classList.add('edbuy-notice-open');

        var closeTargets = modal.querySelectorAll('[data-edbuy-notice-close]');
        Array.prototype.forEach.call(closeTargets, function (target) {
            target.addEventListener('click', closeEdBuyNotice, { once: true });
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                closeEdBuyNotice();
            }
        }, { once: true });

        var button = modal.querySelector('.edbuy-notice__button');
        if (button) {
            button.focus();
        }
    }

    function pointEdBuyContinueShopping() {
        var links = document.querySelectorAll('[data-edbuy-continue-shopping]');
        Array.prototype.forEach.call(links, function (link) {
            link.setAttribute('href', ED_BUY_COLLECTION_PATH);
        });
    }


    window.EdBuySession = {
        collectionHandle: ED_BUY_COLLECTION_HANDLE,
        collectionPath: ED_BUY_COLLECTION_PATH,
        isActive: isEdBuyMode,
        buildSearchUrl: buildEdBuySearchUrl
    };

    if (isEdBuyMode()) {
        window.Shopify.routes.root = ED_BUY_COLLECTION_PATH;
        $('.shopify-payment-button').hide();
        document.documentElement.classList.add('edbuy-session');
        configureEdBuySearchUi();
        showEdBuyNotice();
        // showEdBuyCollectionSearchNotice();
        runEdBuyCollectionSearch();
        pointEdBuyContinueShopping();
        console.log('ED Buy punchout session detected');
    }
});



